import(/* webpackMode: "eager" */ "/vercel/path0/web/app/propiedad/[slug]/error.tsx");
